import { render } from "./LoadingOverlay1.vue?vue&type=template&id=21e97c77&scoped=true"
import script from "./LoadingOverlay1.vue?vue&type=script&lang=js"
export * from "./LoadingOverlay1.vue?vue&type=script&lang=js"

import "./LoadingOverlay1.vue?vue&type=style&index=0&id=21e97c77&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-21e97c77"

export default script